import React from 'react'
import { Footer, Navbar } from "../components";
// import breadcrumbBanner from "../assets/img/breadcrumb/01.jpg";

// const breadcrumbbg = {
//   backgroundImage: `url(${breadcumbBanner})`,
// };
const AboutPage = () => {
  return (
    <>
      <Navbar />
        <div class="site-breadcrumb">
            <div class="container">
                <h2 class="breadcrumb-title">About Us</h2>
                <ul class="breadcrumb-menu">
                    <li><a href="#">Home</a></li>
                    <li class="active">About Us</li>
                </ul>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="terms-content">
                            <h3>About company</h3>
                            <p>PadhaiDekho.com: Revolutionizing Education through Connection and Growth.</p>
                            <p>PadhaiDekho is an innovative edtech startup designed to empower teachers, professors, institutes, colleges across worldwide by enhancing their visibility and marketing efforts. Founded by a passionate CEO, the platform aims to streamline lead generation and facilitate Business  growth for educators in a rapidly evolving educational landscape.</p>
                            <p>PadhaiDekho is India's largest and most trusted Learning Network. Our vision is to be one-stop learning partner for every Indian. With over 50 Thousand Verified Tutors, Trainers, Institutes and colleges. we are a trusted partner of choice for more than 10 lakh students, parents and professionals visiting us every month to fulfill learning requirements across more than 1000 categories.</p>
                            <p>Using PadhaiDekho.com, students, parents and professionals can compare multiple Tutors, Trainers, Institutes and colleges and choose the ones that best suit their requirements.</p>
                            <p>If you are a Tutor, Trainer or an Institute or colleges, you can get relevant enquiries based on your skills and offer online as well as offline coaching services. Also marketing and advertisement for the growth of business.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <Footer />
    </>
  )
}

export default AboutPage